export default "__VITE_ASSET__e6f6b21c__"